import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnowledgeBaseService, KBArticle } from '../../services/knowledge-base.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-kb-article-view',
  templateUrl: './kb-article-view.component.html',
  styleUrls: ['./kb-article-view.component.css']
})
export class KbArticleViewComponent implements OnInit {
  article: KBArticle = null;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private kb: KnowledgeBaseService,
    public auth: AuthService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loading = true;
      this.kb.getArticleBySlug(params['articleSlug']).subscribe(article => {
        this.article = article;
        this.loading = false;
      });
    });
  }
}
